'use client';


import { Icon } from "../components/Icon/Icon.js";
import { c } from "react-compiler-runtime";
import { createIcon } from "@chakra-ui/icon";
import { jsx } from "react/jsx-runtime";

//#region src/utils/createIcon.tsx
function createIcon$1(options) {
	const BaseIcon = createIcon(options);
	const IconWrapper = (props) => {
		const $ = c(3);
		let t0;
		if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
			t0 = options.fill && { fill: options.fill };
			$[0] = t0;
		} else t0 = $[0];
		let t1;
		if ($[1] !== props) {
			t1 = /* @__PURE__ */ jsx(Icon, {
				...t0,
				...props,
				as: BaseIcon
			});
			$[1] = props;
			$[2] = t1;
		} else t1 = $[2];
		return t1;
	};
	IconWrapper.displayName = `${options.displayName}`;
	return IconWrapper;
}

//#endregion
export { createIcon$1 as createIcon };
//# sourceMappingURL=createIcon.js.map